import { cn } from '@ui-kit/utils';
import type { AnimationItem } from 'lottie-web/build/player/lottie_light';
import lottie from 'lottie-web/build/player/lottie_light';
import { useEffect, useRef } from 'react';
import bouncyCircleLoader from '@/assets/animations/bouncyCircleLoader.lottie.json';
import timeHourglass from '@/assets/animations/timeHourglass.lottie.json';

const ANIMATION_DATA_MAP = {
  bouncyCircleLoader,
  timeHourglass,
};

type Props = {
  animation: keyof typeof ANIMATION_DATA_MAP;
  width?: string;
  className?: string;
};

const Animation = ({ animation, width, className }: Props) => {
  const elementRef = useRef(null);

  useEffect(() => {
    let animationItem: AnimationItem;
    if (elementRef.current !== null) {
      animationItem = lottie.loadAnimation({
        container: elementRef.current,
        animationData: ANIMATION_DATA_MAP[animation],
      });
    }

    return function cleanup() {
      animationItem?.destroy();
    };
  }, [animation]);

  return (
    <div
      data-testid="animation-wrapper"
      className={cn('inline-flex', className)}
      style={{ width }}
      ref={elementRef}
    />
  );
};

export default Animation;
